module.exports = __webpack_public_path__ + "img/tcys.43ba5af3.png";